const ADULT_AGE = 0
const AGE_LIMIT = 100
export const DEFAULT_DATE_GAP = 29

const now = new Date()

export const MAX_DATE = new Date(now.getFullYear() - ADULT_AGE, now.getMonth(), now.getDate())
export const MIN_DATE = new Date(now.getFullYear() - AGE_LIMIT, now.getMonth(), now.getDate())

export const DEFAULT_DATE = 'd MMM yyyy'
export const DEFAULT_DATE_AR = 'd MMMM yyyy'
